export default (state, payload) => {
    state.systems_heartbeat_filters.is_health_ok = payload;
  };